import { apiHelper } from "./core"
const baseUrl = process.env.REACT_APP_CLINICAL_MANAGEMENT_BASE_URL
const baseUrlResource = process.env.REACT_APP_RESOURCE_MANAGEMENT_BASE_URL,
  masterServiceBaseUrl = process.env.REACT_APP_MASTER_BASE_URL

const getGeneticCounsellorDetails = (recordId: any): Promise<any> => {
  return apiHelper
    .get(baseUrl + `/medicalrecords/${recordId}/genetic-counsellor/assessment`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getNutritionistDetails = (recordId: any): Promise<any> => {
  return apiHelper
    .get(baseUrl + `/medicalrecords/${recordId}/nutritionist/assessment`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getPhysiotherapistDetails = (recordId: any): Promise<any> => {
  return apiHelper
    .get(baseUrl + `/medicalrecords/${recordId}/physiotherapist/assessment`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const getPsychologistDetails = (recordId: any): Promise<any> => {
  return apiHelper
    .get(baseUrl + `/medicalrecords/${recordId}/psychologist/assessment`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveGeneticAssessment = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    assessment: { ...data },
  }
  return apiHelper
    .put(
      baseUrl +
        `/medicalrecords/${info.recordId}/genetic-counsellor/assessment`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const savePedigreeDocs = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    pedigree: [...data],
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/genetic-counsellor/pedigree`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveGeneticProgressNotes = (data: any, info: any): Promise<any> => {
  let nextVisitTemp = ""
  if (data?.nextVisit !== "") {
    nextVisitTemp = data?.nextVisit
  } else if (data?.nextVisit1 !== "" && data?.nextVisit2 !== "") {
    nextVisitTemp = `${data?.nextVisit1}$${data?.nextVisit2}`
  } else {
    nextVisitTemp = ""
  }
  let consultantDetails: any = {
    prescriptionPad: data?.prescriptionPlans,
    testsRequired: data?.testsRequested,
    advice: data?.advice,
    nextVisit: nextVisitTemp,
    referredTo: data?.updatedReferedTos,
    notes: data?.notes,
    signature: data?.signatureData,
  }
  const payload = {
    appointmentId: info.appointmentId,
    progressNotes: { ...consultantDetails },
  }
  return apiHelper
    .put(
      baseUrl +
        `/medicalrecords/${info.recordId}/genetic-counsellor/progress-notes`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveGeneticManagementPlan = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    managementPlan: { ...data },
  }
  return apiHelper
    .put(
      baseUrl +
        `/medicalrecords/${info.recordId}/genetic-counsellor/management-plan`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveNutritionistAssessment = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    assessment: { ...data },
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/nutritionist/assessment`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveNutritionScreeningNotes = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    screening: { ...data },
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/nutritionist/screening`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveNutritionDietPlan = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    dietPlan: { ...data },
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/nutritionist/diet-plan`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveNutritionFollowUp = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    followUp: { ...data },
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/nutritionist/follow-up`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const savePhysiotherapyAssessment = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    assessment: { ...data },
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/physiotherapist/assessment`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const savePhysiotherapyProgressNotes = (data: any, info: any): Promise<any> => {
  let nextVisitTemp = ""
  if (data?.nextVisit !== "") {
    nextVisitTemp = data?.nextVisit
  } else if (data?.nextVisit1 !== "" && data?.nextVisit2 !== "") {
    nextVisitTemp = `${data?.nextVisit1}$${data?.nextVisit2}`
  } else {
    nextVisitTemp = ""
  }
  let consultantDetails: any = {
    prescriptionPad: data?.prescriptionPlans,
    testsRequired: data?.testsRequested,
    advice: data?.advice,
    nextVisit: nextVisitTemp,
    referredTo: data?.updatedReferedTos,
    signature: data?.signatureData,
    notes: data?.notes,
  }
  const payload = {
    appointmentId: info.appointmentId,
    progressNotes: { ...consultantDetails },
  }
  return apiHelper
    .put(
      baseUrl +
        `/medicalrecords/${info.recordId}/physiotherapist/progress-notes`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const saveAdditionalNotes = (
  data: any,
  id: any,
  recordId: any,
  origin: any
): Promise<any> => {
  const payload = {
    appointmentId: id,
    progressNotes: { ...data },
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${recordId}/${origin}/progress-notes`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const savePsychologyAssessment = (data: any, info: any): Promise<any> => {
  const payload = {
    appointmentId: info.appointmentId,
    assessment: { ...data },
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/psychologist/assessment`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const savePsychologyProgressNotes = (data: any, info: any): Promise<any> => {
  let nextVisitTemp = ""
  if (data?.nextVisit !== "") {
    nextVisitTemp = data?.nextVisit
  } else if (data?.nextVisit1 !== "" && data?.nextVisit2 !== "") {
    nextVisitTemp = `${data?.nextVisit1}$${data?.nextVisit2}`
  } else {
    nextVisitTemp = ""
  }
  let consultantDetails: any = {
    prescriptionPad: data?.prescriptionPlans,
    testsRequired: data?.testsRequested,
    advice: data?.advice,
    nextVisit: nextVisitTemp,
    referredTo: data?.updatedReferedTos,
    signature: data?.signatureData,
    notes: data?.notes,
  }
  const payload = {
    appointmentId: info.appointmentId,
    progressNotes: { ...consultantDetails },
  }
  return apiHelper
    .put(
      baseUrl + `/medicalrecords/${info.recordId}/psychologist/progress-notes`,
      payload
    )
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

const checkIcdDrugInteraction = (data: any): Promise<any> => {
  const medicinesList = data?.medicines?.map(
    (m: any) => `drugNames=${m?.medicineName}`
  )
  const payload = medicinesList.join("&")
  console.log(baseUrl + `/drug-interaction/exact?${payload}`, "API URL")
  return apiHelper
    .get(baseUrl + `/drug-interaction/exact?${payload}`)
    .then((res) => {
      return res?.data
    })
    .catch((err) => Promise.reject(err))
}

export {
  getGeneticCounsellorDetails,
  getNutritionistDetails,
  getPhysiotherapistDetails,
  getPsychologistDetails,
  saveGeneticAssessment,
  savePedigreeDocs,
  saveGeneticProgressNotes,
  saveGeneticManagementPlan,
  saveNutritionistAssessment,
  saveNutritionScreeningNotes,
  saveNutritionDietPlan,
  saveNutritionFollowUp,
  savePhysiotherapyAssessment,
  savePhysiotherapyProgressNotes,
  saveAdditionalNotes,
  savePsychologyAssessment,
  savePsychologyProgressNotes,
  checkIcdDrugInteraction,
}
